import service from '../../../service/index';
import ui from '@/ui';

export default {
  creatHuaweiOrder({}, data) {
    return ui.withLoading(service.createVipOrder)(data);
  },
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/huaweiVIP/store/actions.js